import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/member/right.png'


const _withScopeId = n => (_pushScopeId("data-v-78e59cc3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "member-main flex" }
const _hoisted_2 = { class: "left-container" }
const _hoisted_3 = { class: "header-container flex-a-center" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "user-box" }
const _hoisted_6 = { class: "user-name" }
const _hoisted_7 = { class: "menu-container" }
const _hoisted_8 = { class: "menu-box" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { class: "left-box flex-a-center" }
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "name" }
const _hoisted_14 = {
  key: 0,
  class: "right-icon",
  src: _imports_0,
  alt: ""
}
const _hoisted_15 = { class: "left-box flex-a-center" }
const _hoisted_16 = ["src"]
const _hoisted_17 = { class: "name" }
const _hoisted_18 = {
  key: 0,
  class: "right-icon",
  src: _imports_0,
  alt: ""
}
const _hoisted_19 = { class: "right-container" }

import { ref, onMounted } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { storeToRefs } from 'pinia'
import { useUserStoreHook } from "@/store/modules/user";
import { useUser } from '@/composable/useUser'
import Customize from '@/components/customize/Customize.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const { toPath } = useUser()

const userStore = useUserStoreHook()
const { userInfo } = storeToRefs(userStore)

const router = useRouter()
const route = useRoute()
const routes = router.getRoutes()

const menu = ref<any>([])

const filterRoutes = () => {
  let arr = routes.filter(item => item.name == 'member-index')
  if (arr.length) menu.value = arr[0].children
}

filterRoutes()

onMounted(() => {
})


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: _normalizeClass(['header', 'mr15', {'vip': _unref(userInfo).vip == 1}])
        }, [
          _createElementVNode("img", {
            src: _unref(userInfo).avatar,
            alt: ""
          }, null, 8, _hoisted_4)
        ], 2),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("p", _hoisted_6, _toDisplayString(_unref(userInfo).username), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menu.value, (v, i) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
              (!v.meta.hidden)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(['menu-item', 'flex-a-center', 'cursor-pointer', { 'router-link-active': v.path == _unref(route).path }]),
                    onClick: ($event: any) => (_unref(toPath)(v))
                  }, [
                    (v.meta.showDialog)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                          _createVNode(Customize, {
                            placement: "right",
                            offset: 60
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_11, [
                                _createElementVNode("img", {
                                  class: "mr21",
                                  src: require(`@/assets/member/${v.meta.icon}`),
                                  alt: ""
                                }, null, 8, _hoisted_12),
                                _createElementVNode("p", _hoisted_13, _toDisplayString(v.meta.title), 1)
                              ]),
                              (v.meta.showArrow)
                                ? (_openBlock(), _createElementBlock("img", _hoisted_14))
                                : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1024)
                        ]))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createElementVNode("div", _hoisted_15, [
                            _createElementVNode("img", {
                              class: "mr21",
                              src: require(`@/assets/member/${v.meta.icon}`),
                              alt: ""
                            }, null, 8, _hoisted_16),
                            _createElementVNode("p", _hoisted_17, _toDisplayString(v.meta.title), 1)
                          ]),
                          (v.meta.showArrow)
                            ? (_openBlock(), _createElementBlock("img", _hoisted_18))
                            : _createCommentVNode("", true)
                        ], 64))
                  ], 10, _hoisted_9))
                : _createCommentVNode("", true)
            ], 64))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_19, [
      _createVNode(_component_router_view)
    ])
  ]))
}
}

})